import { createSelector } from '@reduxjs/toolkit'
import { TRootState } from 'store/types'

const selector = (state: TRootState) => state.campaign
const campaign = createSelector(selector, state => state.campaign)

export const campaignSelectors = { campaign }
